module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Seattle City Council Districts")]), _vm._v(" "), _c('div', {
    staticClass: "l-grid l-grid-xsmall"
  }, [_vm._l((_vm.districts), function(district) {
    return _c('div', {
      staticClass: "card"
    }, [_c('h2', {
      staticClass: "card-h2"
    }, [_c('span', [_vm._v(_vm._s(district.name))])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('router-link', {
      staticClass: "l-width-100 btn teal",
      attrs: {
        "to": {
          name: 'cityCouncilDistrict',
          params: {
            id: district.id
          }
        }
      }
    }, [_vm._v("View " + _vm._s(district.name))]), _vm._v(" "), _c('h3', [_vm._v("Neighborhoods")]), _vm._v(" "), _c('ul', _vm._l((district.neighborhoods), function(neighborhoodName, neighborhoodSlug) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": {
            name: 'neighborhood',
            params: {
              id: neighborhoodSlug
            }
          }
        }
      }, [_vm._v(_vm._s(neighborhoodName))])], 1)
    }), 0)], 1)])
  }), _vm._v(" "), _c('SeattleCityCouncilInformation')], 2), _vm._v(" "), _c('Geo', {
    attrs: {
      "polygons": _vm.polygons
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0aa9012"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CityCouncilDistricts.vue
// module id = 450
// module chunks = 1